import { render, staticRenderFns } from "./LoadingSpiner.vue?vue&type=template&id=02195164&scoped=true&"
import script from "./LoadingSpiner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02195164",
  null
  
)

export default component.exports